import type { Service } from '../models'

export function hasSpecificServiceUnavailable(isService: Service | boolean): isService is Exclude<Service, 'global'> {
  return typeof isService === 'string' && isService !== 'global'
}
